import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=53c48b2c"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"
import style0 from "./Step4.vue?vue&type=style&index=0&id=53c48b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports